export default {"src":"/_next/static/media/hypotenuse_logo_text_light.528e87d3.svg","height":28,"width":212};